import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orgName: '',
  orgId: '',
  permissions: [],
  subAdminBoolean: true,
  userTheme: '',
  accessLogsCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  accessLogsNameSearch: '',
  organizationList: [],
  shouldRefreshOrgList: false,
  // Audit logs filters
  auditLogsCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  auditLogsNameSearch: '',
};

export const commonSlice = createSlice({
  initialState,
  name: 'common',
  reducers: {
    setOrgName: (state, action) => {
      return { ...state, orgName: action.payload };
    },
    setOrg: (state, action) => {
      return { ...state, orgId: action.payload };
    },
    setPermissions: (state, action) => {
      return { ...state, permissions: action.payload };
    },
    setsubAdminBoolean: (state, action) => {
      return { ...state, subAdminBoolean: action.payload };
    },
    setUserTheme: (state, action) => {
      return { ...state, userTheme: action.payload };
    },
    setAccessLogsCreatedOnFilter: (state, action) => {
      return {
        ...state,
        accessLogsCreatedOnFilter: action.payload
          ? { ...action.payload }
          : { ...initialState.accessLogsCreatedOnFilter },
      };
    },
    setAccessLogsNameSearch: (state, action) => {
      return {
        ...state,
        accessLogsNameSearch: action.payload,
      };
    },
    setOrganizationList: (state, action) => {
      return {
        ...state,
        organizationList: action.payload,
      };
    },
    setShouldRefreshOrgList: (state, action) => {
      return {
        ...state,
        shouldRefreshOrgList: action.payload,
      };
    },
    reset: () => initialState,
    // Audit logs filter reducers
    setAuditLogsCreatedOnFilter: (state, action) => {
      return {
        ...state,
        auditLogsCreatedOnFilter: action.payload
          ? { ...action.payload }
          : { ...initialState.auditLogsCreatedOnFilter },
      };
    },
    setAuditLogsNameSearch: (state, action) => {
      return {
        ...state,
        auditLogsNameSearch: action.payload,
      };
    },
  },
});

export const {
  setOrgName,
  setPermissions,
  setsubAdminBoolean,
  setUserTheme,
  setAccessLogsCreatedOnFilter,
  setAccessLogsNameSearch,
  reset,
  setShouldRefreshOrgList,
  // Audit log filters
  setAuditLogsCreatedOnFilter,
  setAuditLogsNameSearch,
} = commonSlice.actions;

export default commonSlice.reducer;
